import React from 'react';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ManagePageHeader from 'components/ManagePageHeader/ManagePageHeader';
import action_library_messages from 'messages/action_library_messages';

import ActionTemplateForm from './ActionTemplateForm';

const ActionLibraryCreatePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <ManagePageHeader backButton subtitle={t(action_library_messages.create_subtitle)}>
        {t(action_library_messages.create_button)}
      </ManagePageHeader>
      <ActionTemplateForm />
    </Container>
  );
};

export default ActionLibraryCreatePage;
